<div class="legal-dialog">
  <div class="legal-dialog__header">
    <div>
      <div class="legal-dialog__eyebrow">LEGAL</div>
      <h2>Privacidad y Politicas</h2>
    </div>

    <button class="legal-dialog__close" type="button" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="legal-dialog__body" *ngIf="!loading && visiblePolicyTypes.length; else legalLoading">
    <aside class="legal-dialog__nav">
      <button
        type="button"
        *ngFor="let item of visiblePolicyTypes"
        (click)="selectPolicy(item.type)"
        [class.active]="selectedType === item.type"
      >
        {{ item.label }}
      </button>
    </aside>

    <section class="legal-dialog__content" *ngIf="selectedPolicy as policy">
      <div class="legal-dialog__meta">
        <div class="legal-dialog__title">{{ policy.titulo }}</div>
        <div class="legal-dialog__edition" *ngIf="policy.edicion">Version {{ policy.edicion }}</div>
      </div>

      <div class="legal-dialog__html" [innerHTML]="policy.contenido"></div>
    </section>
  </div>

  <ng-template #legalLoading>
    <div class="legal-dialog__empty">
      {{ loading ? 'CARGANDO POLITICAS...' : 'NO HAY POLITICAS DISPONIBLES.' }}
    </div>
  </ng-template>
</div>
